import Vue from 'vue'
import qs from 'qs'
import axios from 'axios'
import { Toast } from 'vant';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
axios.defaults.headers.post['Accept'] = 'application/json, text/javascript, */*; q=0.01';

axios.interceptors.request.use((config) => {
  if (config.method === 'post' && !(config.data instanceof FormData)) {
    config.data = qs.stringify(config.data);
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});
axios.interceptors.response.use(rs => {
  let data = rs.data,
    error = data.Exception&&data.ExceptionMessage;
  if (error && !rs.config.catch) {
    Toast(error);
    return Promise.reject({ error });
  } else {
    return data;
  }
}, error => {
  // 对响应错误做点什么
  return Promise.reject(error);
});

Vue.prototype.$axios = axios;